import { mccs_vehicle_review_request_status } from '@/@types/generated'
import { register } from './enum'

export const VehicleReviewRequestStatusTextColor: Record<
  mccs_vehicle_review_request_status,
  string
> = {
  [mccs_vehicle_review_request_status.PENDING]: 'text-purple-400',
  [mccs_vehicle_review_request_status.MORE_INFO_NEEDED]: 'text-amber-500',
  [mccs_vehicle_review_request_status.APPROVED]: 'text-green-400',
  [mccs_vehicle_review_request_status.REJECTED]: 'text-red-500',
  [mccs_vehicle_review_request_status.CANCELLED]: 'text-muted-foreground',
}

export const VehicleReviewRequestStatusLabels: Record<
  mccs_vehicle_review_request_status,
  string
> = {
  [mccs_vehicle_review_request_status.PENDING]: 'Pending',
  [mccs_vehicle_review_request_status.MORE_INFO_NEEDED]:
    'More Information Needed',
  [mccs_vehicle_review_request_status.APPROVED]: 'Approved',
  [mccs_vehicle_review_request_status.REJECTED]: 'Rejected',
  [mccs_vehicle_review_request_status.CANCELLED]: 'Cancelled',
}

register<mccs_vehicle_review_request_status>(
  mccs_vehicle_review_request_status,
  (v) => {
    if (!v) return '—'
    return VehicleReviewRequestStatusLabels[v]
  }
)
